import { render, staticRenderFns } from "./ShopsFilterModal.vue?vue&type=template&id=ebbf066c&scoped=true&"
import script from "./ShopsFilterModal.vue?vue&type=script&lang=js&"
export * from "./ShopsFilterModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopsFilterModal.vue?vue&type=style&index=0&id=ebbf066c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbf066c",
  null
  
)

export default component.exports